import { graphql } from "@/lib/gql/__generated__";

export const HOTEL_APPLICATION_DATA_MUTATION = graphql(/* GraphQL */ `
	mutation HotelApplicationDataMutation($input: BillingStatusUpdateInput!) {
		billingStatusUpdate(input: $input) {
			userErrors
		}
	}
`);
